import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeCollaboration extends Shape {
    width = 200;
    height = 153;
    defaultBorderDashType = "dashed";
    defaultBorderWidth = 3;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width * 0.5 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
        canv.ctx.moveTo(x + (w * 4) / 22, y + h / 2);
        canv.ctx.lineTo(x + (w * 18) / 22, y + h / 2);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m14.6213 3.72723c-.8144-.14709-1.6881-.22723-2.6213-.22723-.8872 0-1.7208.07245-2.50059.20599m0 16.58331c.77979.1366 1.61339.2107 2.50059.2107.9332 0 1.8069-.082 2.6213-.2324m-8.20426-.9433c-.86321-.4078-1.62321-.9025-2.28004-1.4526m0-11.79558c.65683-.5404 1.41683-1.02556 2.28004-1.42523m-4.74027 4.52156c-.45121.94785-.67677 1.90365-.67677 2.76945 0 .938.26476 1.9901.79441 3.0272m20.41119 0c.5296-1.0371.7944-2.0892.7944-3.0272 0-.8658-.2256-1.8216-.6768-2.76945m-4.7402-4.52156c.8632.39967 1.6232.88483 2.28 1.42523m0 11.79558c-.6568.5501-1.4168 1.0448-2.28 1.4526m-12.52523-7.3752h3.37981m2.55552 0h2.1749m2.512 0h3.337"
                stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
